import { Box, Stack, useTheme } from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { H5, H8 } from '../../components/Typography';
import FlexBox from '../../components/flexbox/FlexBox';

const CategoryBox = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const [searchParams] = useSearchParams();

  // Get current category and subcategory from URL
  const currentCategory = searchParams.get('category');
  const currentSubcategory = searchParams.get('subcategory');

  // Check if "all" is selected or no category is selected (default to all)
  const isAllSelected =
    (!currentCategory && !currentSubcategory) ||
    (currentCategory === 'all' && !currentSubcategory);

  // Category dataset
  const categoryData = [
    {
      id: 'all',
      title: '전체',
      color: '#373737',
      isAll: true,
    },
    {
      id: 'enterprise',
      title: '기업마당',
      color: '#373737',
      subCategories: [
        {
          id: 'enterprise-finance',
          name: '금융',
          category: 'enterprise',
          subcategory: 'finance',
        },
        {
          id: 'enterprise-tech',
          name: '기술',
          category: 'enterprise',
          subcategory: 'tech',
        },
        {
          id: 'enterprise-hr',
          name: '인력',
          category: 'enterprise',
          subcategory: 'hr',
        },
        {
          id: 'enterprise-export',
          name: '수출',
          category: 'enterprise',
          subcategory: 'export',
        },
      ],
    },
    {
      id: 'kstartup',
      title: 'K스타트업',
      color: '#373737',
      subCategories: [
        {
          id: 'kstartup-tech',
          name: '기술',
          category: 'kstartup',
          subcategory: 'tech',
        },
        {
          id: 'kstartup-hr',
          name: '인력',
          category: 'kstartup',
          subcategory: 'hr',
        },
        {
          id: 'kstartup-export',
          name: '수출',
          category: 'kstartup',
          subcategory: 'export',
        },
      ],
    },
    {
      id: 'sba',
      title: 'SBA',
      color: '#373737',
      subCategories: [
        {
          id: 'sba-tech',
          name: '기술',
          category: 'sba',
          subcategory: 'tech',
        },
        {
          id: 'sba-hr',
          name: '인력',
          category: 'sba',
          subcategory: 'hr',
        },
        {
          id: 'sba-export',
          name: '수출',
          category: 'sba',
          subcategory: 'export',
        },
      ],
    },
  ];

  return (
    <Box
      sx={{
        backgroundColor: '#ffffff',
        borderRadius: '24px',
        padding: '0px 0px 20px 0px', // Removed top/side padding
        boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.08)',
        border: '1px solid #f0f0f0',
        overflow: 'hidden', // Ensure child radius doesn't overflow
      }}
    >
      <Stack spacing={0}>
        {categoryData.map(category => (
          <Box key={category.id}>
            {category.isAll ? (
              <Box
                onClick={() => navigate('/naver/callmetellme/jiwongum')}
                sx={{
                  width: '100%',
                  marginBottom: '0px',
                  borderRadius: '0px',
                  backgroundColor: isAllSelected
                    ? theme.palette.grey[100]
                    : theme.palette.grey[100],
                  padding: '20px 20px 20px 28px',
                  cursor: 'pointer',
                  '&:hover': {
                    backgroundColor: theme.palette.grey[100],
                  },
                }}
              >
                <H5
                  sx={{
                    color: isAllSelected
                      ? theme.palette.primary.mainBlue
                      : '#373737',
                    fontWeight: 700,
                    fontSize: '16px',
                  }}
                >
                  {category.title}
                </H5>
              </Box>
            ) : (
              <Box px="20px">
                <FlexBox
                  onClick={() =>
                    navigate(
                      `/naver/callmetellme/jiwongum?category=${category.id}`
                    )
                  }
                  sx={{
                    cursor: 'pointer',
                    marginTop: '12px',
                    marginBottom: '4px',
                    padding: '4px 8px',
                    borderRadius: '8px',
                    backgroundColor:
                      currentCategory === category.id && !currentSubcategory
                        ? theme.palette.grey[100]
                        : 'transparent',
                    transition: 'all 0.2s ease',
                    '&:hover': {
                      backgroundColor:
                        currentCategory === category.id && !currentSubcategory
                          ? theme.palette.grey[100]
                          : theme.palette.grey[50],
                    },
                  }}
                >
                  <H5
                    sx={{
                      color:
                        currentCategory === category.id && !currentSubcategory
                          ? theme.palette.primary.mainBlue
                          : category.color,
                      fontWeight: 700,
                      fontSize: '16px',
                    }}
                  >
                    {category.title}
                  </H5>
                </FlexBox>
                {/* Sub-categories */}
                <Stack spacing={0.5}>
                  {category.subCategories.map(subCategory => {
                    const isActive =
                      currentCategory === subCategory.category &&
                      currentSubcategory === subCategory.subcategory;

                    return (
                      <FlexBox
                        key={subCategory.id}
                        onClick={() =>
                          navigate(
                            `/naver/callmetellme/jiwongum/category?category=${subCategory.category}&subcategory=${subCategory.subcategory}`
                          )
                        }
                        sx={{
                          alignItems: 'center',
                          cursor: 'pointer',
                          padding: '4px 8px',
                          borderRadius: '8px',
                          backgroundColor: isActive
                            ? theme.palette.grey[100]
                            : 'transparent',
                          transition: 'all 0.2s ease',
                          '&:hover': {
                            backgroundColor: isActive
                              ? theme.palette.grey[100]
                              : theme.palette.grey[50],
                          },
                        }}
                      >
                        <H8
                          sx={{
                            color: isActive
                              ? theme.palette.primary.mainBlue
                              : '#6B7280', // Gray color
                            fontWeight: isActive ? 600 : 500,
                          }}
                        >
                          {subCategory.name}
                        </H8>
                      </FlexBox>
                    );
                  })}
                </Stack>
              </Box>
            )}
          </Box>
        ))}
      </Stack>
    </Box>
  );
};

export default CategoryBox;
